import styled from 'styled-components';

export const ToastWrapper = styled.div`
  position: fixed;
  bottom: 10%;
  right: 5%;
  z-index: 999;
  /* width: 264px; */
  height: 100px;
  opacity: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--nightBlue);
  color: var(--white);
  border-radius: 1rem;
  box-shadow: 0 1rem 2rem -1rem rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  h5 {
    letter-spacing: 1px;
    margin: 0 0 0.5rem 0;
    text-transform: uppercase;

    &.success {
      color: var(--success);
    }
    &.error {
      color: var(--error);
    }
  }
  p {
    padding: 0 2rem;
    margin: 0;
  }

  animation: appear 4s ease;

  @keyframes appear {
    0% {
      opacity: 0;
      transform: translateY(-100%);
    }

    25% {
      opacity: 1;
      transform: translateY(0%);
    }
    /* 50% {
      opacity: 1;
      transform: translateY(0%);
    } */
    75% {
      opacity: 1;
      transform: translateY(0%);
    }
    100% {
      opacity: 0;
      transform: translateY(-100%);
    }
  }
`;
